import React from 'react';
import {
    TextInput,
    Edit,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    ReferenceArrayInput,
    SelectArrayInput
} from 'react-admin';
import { usePermissions } from 'react-admin';
import { ROLE_ADMIN, isInRole } from '../authProvider';

const required = (message = 'Required') =>
    value => value ? undefined : message;

const UserEdit = (props) => {
        const { permissions } = usePermissions();
        const isAdmin = isInRole(ROLE_ADMIN, permissions);
        return (
        <Edit {...props}>
            <SimpleForm>
                <TextInput source="email" disabled />
                <TextInput source="surname" validate={required()} disabled={(!isAdmin)}/>
                <TextInput source="givenName" validate={required()} disabled={(!isAdmin)}/>
                <TextInput source="company" disabled={(!isAdmin)}/>
                <TextInput source="companyType" disabled={(!isAdmin)}/>
                <TextInput source="title" disabled={(!isAdmin)}/>
                <TextInput source="phoneNumber" disabled={(!isAdmin)}/>
                <TextInput source="contactPerson" disabled={(!isAdmin)}/>
                <TextInput source="city" disabled={(!isAdmin)}/>
                <ReferenceInput label="Country/Region" source="country" reference="countries" disabled={(!isAdmin)}>
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <ReferenceInput source="segmentId" reference="HEXSelector/AccountRequestSegments" label="Segment" disabled={(!isAdmin)}>
                    <SelectInput optionText="name" />
                </ReferenceInput>
                {isAdmin ?
                <ReferenceArrayInput source="roleIds" reference="roles" label="Roles">
                    <SelectArrayInput optionText="name" />
                </ReferenceArrayInput>
                : null}
            </SimpleForm>
        </Edit>
        );
    }


export default UserEdit;